import {Headline} from '../../Headline'

import type {HeadlineProps} from '../../Headline'

export const H3 = ({children, ...restProps}: HeadlineProps) => (
  <Headline
    size={3}
    tag={'h3'}
    data-testid={'_h3'}
    className={'mb-spacing-12'}
    {...restProps}
  >
    {children}
  </Headline>
)
